<template>
  <el-dialog
    width="934px"
    title="通用查询"
    v-drag
    id="kye-custom-filter-dialog"
    class="kye-dialog__modal-in-tab kye-custom-filter-dialog noselect"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="escape"
    :canResize="false"
    :showFullScreenButton="false"
    :visible.sync="show"
    @open="onOpen"
    @close="onClose">
    <div class="main-wrap">
      <custom-filter-module
        ref="customFilterModule"
        :model="model"
        :module="module"
        :showBatchRemove="showBatchRemove"
        :templateList="templateList"
        @showNameDialog="showNameDialog"
        @removeTemplate="removeTemplate"
        @changeFolder="changeFolder"
        @moveFolder="moveFolder"
        @loadTemplate="loadTemplate">
      </custom-filter-module>
      <rule class="main-wrap_right" ref="rule" height="420" :module="module" :inner="true" />
    </div>
    <div slot="footer" class="kye-custom-filter-dialog__footer">
      <kye-button
        type="text"
        style="margin-left:4px;"
        v-show="!showBatchRemove"
        @click="removeTemplate(-1)">删除
      </kye-button>
      <kye-button
        type="text"
        style="margin-left:4px;"
        v-show="!showBatchRemove"
        @click="cancelRemove">取消
      </kye-button>
      <kye-button
        type="text"
        style="margin-left:0px;"
        auth="BTonkLNcnhiZ"
        class="layout layout-shared"
        v-show="showBatchRemove"
        @click="showShareDialog">
        分享
      </kye-button>
      <el-dropdown @command="handleCommand" v-show="showBatchRemove" trigger="click">
        <kye-button
          type="text"
          style="margin-left:4px;"
          auth="BTonkLNcnhiZ"
          class="layout layout-a-gengduo3"
          > 更多
        </kye-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="showRemove" :disabled="templateList.length === 0">
            <i class="layout layout-piliangshanchu custom-filter-icon-size"></i>
            批量删除
          </el-dropdown-item>
          <el-dropdown-item command="showImportDialog">
            <i class="layout layout-daoru custom-filter-icon-size"></i>
            导入
          </el-dropdown-item>
          <el-dropdown-item command="exportRules">
            <i class="layout layout-export custom-filter-icon-size"></i>
            导出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span style="flex:1;"></span>
      <el-button
        type="primary"
        icon="layout layout-reset"
        v-if="showResetBtn"
        @click="onReset">重置
      </el-button>
      <el-button
        type="primary"
        icon="layout layout-plus"
        @click="addRule">新增一条
      </el-button>
      <el-button
        type="primary"
        hotkey="ctrl+s"
        icon="layout layout-baocun"
        :disabled="!model.templateId || model.folderFlag === 1"
        @click="saveTemplate">保存(S)
      </el-button>
      <el-button
        type="primary"
        icon="layout layout-save"
        @click="createTemplate">另存为
      </el-button>
      <el-button
        type="primary"
        hotkey="ctrl+q"
        icon="layout layout-search1"
        @click="onQuery">查询(Q)
      </el-button>
      <el-button
        style="padding-left:20px;padding-right:20px;"
        @click="show = false">取消
      </el-button>
    </div>
    <name-dialog
      ref="nameDialog"
      :escape="escape"
      :model="model"
      @change="() => saveTemplate('rename')" />
    <import-dialog
      ref="importDialog"
      :escape="escape"
      :beforeSave="rules => this.validateMaxSearchCount('import', rules)"
      @change="importRules" />
    <share-dialog
      v-if="hasShareAuth"
      ref="shareDialog"
      :shareRequestUrl="shareRequestUrl"
      :escape="escape"
      :templates="templateList"
      :maxRows="model.maxRows"
      @close="closeShareDialog"
    />
  </el-dialog>
</template>

<script>
  import keydownEvent from '../../utils/hotkey'
  import rule from './custom-filter-rule'
  import nameDialog from './template-name-dialog'
  import importDialog from './template-import-dialog'
  import shareDialog from './template-share-dialog'
  import customFilterModule from './custom-filter-module'
  import { filterFieldsByAuthCode } from './utils'
  import { SHARED2_URL } from 'public/utils/common-api.js'

  const GENERIC_NAME = 'GLOBAL_SEARCH_GENERIC'

  export default {
    name: 'custom-filter',
    components: { rule, nameDialog, importDialog, shareDialog, customFilterModule },
    props: {
      module: Object,
      initTemplate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        shareRequestUrl: SHARED2_URL,
        show: false,
        showBatchRemove: true,
        // templateKey: '',
        templateList: [],
        ruleOption: {},
        model: {
          esFlag: true,
          genericId: '',
          fields: null,
          templateId: '',
          templateName: '',
          parentId: '',
          folderFlag: 0,
          // 查询条件数量限制
          searchCountFlag: 0, // 是否限制查询条件数量， 0否， 1是
          maxRows: 0, // 最大查询条件数量
          searchScene: [] // 限制查询条件的场景
        },
        escape: true,
        btnOptions: [
          {
            label: '导入',
            value: 1
          },
          {
            label: '导出',
            value: 2
          }
        ]
      }
    },
    created () {
      this.initProps()
    },
    computed: {
      showResetBtn () {
        const list = this.$store.state.lookUpOptions['sys_generic_reset_white_list']
        const tag = this.$route.meta.tag
        return !(list && tag && list.find(item => item.value === tag))
      },
      hasShareAuth () {
        return this.$store.getters.permission.menus.includes('BTonkLNcnhiZ')
      }
    },
    methods: {
      // 对外暴露，merge 查询条件
      setGenericFields (option) {
        this.ruleOption = option
      },
      setGenericSearchFields (obj) {
        this.resetMaxSearchCount()
        if (obj && obj.columnList && obj.columnList.length) {
          this.model.genericId = obj.id
          this.model.esFlag = obj.esFlag === '10'
          obj.columnList = filterFieldsByAuthCode(obj.columnList, 'generic')
          obj.columnList.forEach(v => {
            v.key = this.model.esFlag ? v.propertyName : v.columnName
          })
          this.model.fields = obj.columnList
          // 查询最大数量限制转换为前端标识
          this.setMaxSearchCount({...obj, maxRows: obj.allowMaxCount || 0})
          this.mergeModule(this.model.fields)
          this.$emit('loaded', this.model)
          // query-table 通知加载模板
          if (this.initTemplate) {
            this.getTemplateList()
          }
        }
      },
      // 设置查询条件数量限制
      setMaxSearchCount (data) {
        let { searchCountFlag = 0, maxRows = 0, searchScene = [] } = data || {}
        if (typeof searchScene === 'string' && searchScene.startsWith('[')) {
          searchScene = JSON.parse(searchScene)
        }
        Object.assign(this.model, { searchCountFlag, maxRows, searchScene })
      },
      // 重置查询条件数量限制
      resetMaxSearchCount () {
        this.setMaxSearchCount({
          searchCountFlag: 0,
          maxRows: 0,
          searchScene: []
        })
      },
      /**
       * @description 验证是否超过查询条件数量限制
       * @param scene 包含 search-查询、import-导入、export-导出、saveTemplate-保存模板、shared-分享
       */
      validateMaxSearchCount (scene = 'search', rules = []) {
        const { searchCountFlag = 0, maxRows = 0, searchScene = [] } = this.model || {}
        if (+searchCountFlag === 1) {
          // 数量是否超过限制
          const isOver = rules && rules.length > maxRows
          // 是否在限制场景中
          const isInLimitedScene = searchScene.includes(scene)
          if (isOver && isInLimitedScene) {
            this.$message.warning(`当前模块禁用配置超过${maxRows}个查询条件，如有疑问请咨询产品负责人`)
            return false
          }
          return true
        }
        return true
      },
      mergeGenericFields () {
        let originConfigArr = this.module.configColumns
        if (originConfigArr && Array.isArray(originConfigArr)) {
          let fields = originConfigArr
            .reduce((prev, cur) => {
              let key = this.model.esFlag ? cur.propertyName : cur.columnName
              let show = !!cur.$show
              const obj = this.ruleOption[key] || {}
              prev[key] = { ...obj, $show: show, show }
              return prev
            }, {})
          this.ruleOption = fields
          this.$refs.rule && this.$refs.rule.mergeGenericFields(fields)
        }
      },
      mergeModule (arr) {
        if (!this.module.option) {
          this.module.option = {}
        }
        arr.forEach(v => {
          // merge 前端的配置
          v.$attr = Object.assign(v.$attr || {}, this.module.option[v.key])
          // 后台扩展字段支持前端属性
          let attr = v.attribute2
          if (attr) {
            if (typeof attr === 'string') {
              try {
                attr = JSON.parse(attr)
              } catch (e) {
              }
            }
            if (typeof attr === 'object') {
              // 前端的配置覆盖模板的配置
              Object.assign(attr, v.$attr)
              Object.assign(v.$attr, attr)
            }
          }
        })
      },
      resetTemplate (folderFlag = 0) {
        this.model.templateId = ''
        this.model.templateName = ''
        this.model.parentId = ''
        this.model.folderFlag = 0
        // 左侧面板选择文件夹类型，无需重置左侧面板状态
        if (folderFlag !== 1) {
          this.$refs.customFilterModule && this.$refs.customFilterModule.resetTemplate()
        }
      },
      createTemplate () {
        this.resetTemplate()
        let vos = this.$refs.rule.onSubmit()
        if (vos) {
          if (!this.validateMaxSearchCount('saveTemplate', vos)) {
            return
          }
          this.showNameDialog()
        }
      },
      async saveTemplate (type) {
        let data = {}
        if (Number(this.model.folderFlag) === 1) {
          // 文件夹类型
          data = {
            genericId: this.model.genericId,
            name: this.model.templateName,
            folderFlag: this.model.folderFlag,
            id: this.model.templateId
          }
        } else {
          // 模版类型
          let vos = this.$refs.rule.onSubmit()
          if (!vos) {
            return
          }
          if (type !== 'rename' && !this.validateMaxSearchCount('saveTemplate', vos)) {
            return
          }
          data = {
            name: this.model.templateName,
            genericId: this.model.genericId,
            columnList: this.$refs.rule.mapColumnList()
          }
          if (this.model.templateId) {
            data.id = this.model.templateId
          }
          if (this.model.parentId) {
            data.parentId = this.model.parentId
          }
        }
        await this.$http('system.genericSearch.template.saveOrUpdate', data)
        if (this.model.templateId) {
          // 更新操作（本地更新名称和模版的rule规则）
          const updateItem = this.findTemplateListItemById(data.id)
          updateItem.name = this.model.templateName
          if (data.columnList) {
            updateItem.columnList = data.columnList
          }
        } else {
          // 新增从新获取数据
          this.getTemplateList()
        }
        this.resetTemplate()
        this.$message.success('保存成功')
      },
      findTemplateListItemById(id) {
        let findItem = null
        this.templateList.forEach(item => {
          if (item.templateList && item.templateList.length) {
            item.templateList.forEach(newItem => {
              if (newItem.id === id) {
                findItem = newItem
                return true
              }
            })
          }
          if (item.id === id) {
            findItem = item
            return true
          }
        })
        return findItem
      },
      async getTemplateList () {
        let data = { genericId: this.model.genericId }
        const url = this.module.lazyLoadTemplate ? 'system.genericSearch.template.listTreeTemplateByGenericId' : 'system.genericSearch.template.listTreeByGenericId'
        const list = await this.$http(url, data)
        this.templateList = this.resetTemplateList(list)
        this.$emit('onTemplateListChange', this.templateList)
      },
      getRulesById (id) {
        let data = { id }
        return this.$http('system.genericSearch.template.getDetailInfo', data)
      },
      async removeTemplate (templateItem) {
        const isBatch = templateItem === -1
        const templateList = this.templateList
        let checkedListIds = []
        templateList.map(item => {
          if (item._checked) {
            checkedListIds.push(item.id)
          }
          if (item.templateList && item.templateList.length) {
            item.templateList.map(childItem => {
              if (childItem._checked) {
                checkedListIds.push(childItem.id)
              }
            })
          }
        })
        if (isBatch && checkedListIds.length === 0) {
          this.$message.warning('请选择需要删除的数据！')
          return
        }
        let deleteText = templateItem.folderFlag && templateItem.folderFlag === 1 ? '是否删除文件夹？' : '是否删除模板？'
        if (isBatch) {
          deleteText = '是否批量删除？'
        }
        await this.$confirm(deleteText, '提示')
        let ids = isBatch ? checkedListIds : [templateItem.id]
        await this.$http('system.genericSearch.template.delete', { ids })
        this.getTemplateList()
        this.resetTemplate()
        this.$message.success('删除成功')
      },
      handleCommand (command) {
        this[command]()
      },
      changeFolder () {
        this.getTemplateList()
      },
      moveFolder () {
        this.getTemplateList()
      },
      showRemove () {
        this.resetTemplate()
        this.showBatchRemove = false
      },
      cancelRemove () {
        this.showBatchRemove = true
        this.templateList = this.resetTemplateList(this.templateList)
      },
      resetTemplateList (arr) {
        return arr.map(v => {
          let templateList = []
          if (Array.isArray(v.templateList) && v.templateList.length) {
            templateList = v.templateList.map(child => ({ ...child, _checked: false }))
          }
          return {
            ...v,
            templateList,
            _checked: false
          }
        })
      },
      async lazyLoadTemplate (template) {
        const res = await this.getRulesById(template.id)
        this.setRulesByTemplate(res)
      },
      loadTemplate (template) {
        // 批量操作时，不允许加载列表
        if (!this.showBatchRemove) {
          return
        }
        // 文件夹类型不加载规则，并重置model
        if (template.folderFlag === 1) {
          this.resetTemplate(template.folderFlag)
          return
        }
        if (this.module.lazyLoadTemplate) {
          this.lazyLoadTemplate(template)
          return
        }
        this.setRulesByTemplate(template)
      },
      setRulesByTemplate (template) {
        const list = template.columnList
        this.model.parentId = template.parentId
        this.model.templateId = template.id
        this.model.templateName = template.name
        list.sort((a, b) => a.rowIndex - b.rowIndex)
        let rules = list.map(v => ({
          propertyName: v.propertyName,
          columnName: v.columnName,
          frontBrackets: v.frontBrackettemplates,
          postBrackets: v.postBrackets,
          conditionOperation: v.conditionOperation,
          operation: v.operation,
          queryValue: v.queryValue,
          extJson: v.extJson
        }))
        this.$refs.rule.setRules(rules)
      },
      addRule () {
        if (this.$refs.rule.rules.length < 30) {
          this.$refs.rule.addRule()
        }
      },
      importRules (rules) {
        this.$refs.rule.setRules(rules)
      },
      async exportRules () {
        let vos = this.$refs.rule.onSubmit()
        if (vos) {
          try {
            if (!this.validateMaxSearchCount('export', vos)) {
              return
            }
            await this.$confirm('是否将通用查询条件下载到当前文档?', '提示')
            let rules = this.$refs.rule.getValidRules()
            let elink = document.createElement('a')
            elink.download = 'genericSearchRules.txt'
            elink.style.display = 'none'
            let blob = new Blob([JSON.stringify(rules)])
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          } catch (e) {
            console.log(e)
          }
        }
      },
      addRuleEvent (e) {
        if (e.target.className && e.target.className.includes('el-table__body-wrapper')) {
          this.addRule()
        }
      },
      onClose () {
        this.module.disabledLocalCache !== true && this.saveRulesToLocal()
        document.removeEventListener('keydown', this.handleKeydown)
        this.$refs.rule.$el.removeEventListener('click', this.addRuleEvent)
        this.show = false
        this.$emit('close')
      },
      onOpen () {
        this.showBatchRemove = true
        this.resetTemplate()
        this.$nextTick(_ => {
          if (this.model.genericId) {
            this.$refs.rule.setGenericSearchFields(this.model.fields, this.model.esFlag)
            this.getTemplateList()
            this.module.disabledLocalCache !== true && this.getRulesFromLocal()
            this.module.disabledLocalCache === true && this.removeRulesLocal()
          }
          this.$refs.rule.setGenericFields(this.ruleOption)
          this.$refs.rule.$el.addEventListener('click', this.addRuleEvent)

          this.$emit('open')
        })
        // 通用查询弹框可能是在弹框里使用的，这种情况下hotkey查找dom的策略已失效
        document.addEventListener('keydown', this.handleKeydown)
      },
      onQuery () {
        let vos = this.$refs.rule.onSubmit()
        if (!vos) {
          return
        }
        if (!this.validateMaxSearchCount('search', vos)) {
          return
        }
        let data = {
          elasticsearchFlag: this.model.esFlag ? 'Y' : 'N',
          generic: { vos }
        }
        // 埋点上报查询事件条件个数
        window.aplus_queue && window.aplus_queue.push({
          'action': 'aplus.record',
          'arguments': ['erp_custom_filter_search_click', 'CLK', {
            searchNumber: vos.length
          }]
        })
        let fn = this.module.beforeFormSubmit
        if (fn && typeof fn === 'function' && fn(data) === true) {
          return
        }
        this.queryLog_zh_cn = this.getQueryLog_zh_cn()
        this.$emit('submit', data, this.queryLog_zh_cn)
        this.show = false
      },
      initProps () {
        if (!this.module.method || !this.module.searchCode) {
          let msg = 'custom-filter 组件配置错误：method, searchCode 为必选项'
          this.$alert(msg, '提示', { type: 'error', showClose: false })
          return
        }
        if (this.module.sectionOption) {
          this.module.sectionOption.$row = `$${this.module.sectionOption.row}`
        }
        if (!this.module.module) {
          this.module.module = this.module.method
        }
      },
      handleKeydown (e) {
        if (this.$el && (!this.$refs.nameDialog || !this.$refs.nameDialog.show)) {
          keydownEvent(e, this.$el.querySelector('.kye-custom-filter-dialog__footer'))
        }
      },
      getRulesFromLocal () {
        let res = localStorage.getItem(GENERIC_NAME)
        if (res) {
          try {
            let tag = `${this.$route.meta.tag}?${this.module.module}`
            res = JSON.parse(res)
            res = res[tag]
            if (res && Array.isArray(res)) {
              this.$refs.rule.setRules(res)
            }
          } catch (e) {
            console.log(`[contom-filter]: ${e}`)
          }
        }
      },
      saveRulesToLocal () {
        let rules = this.$refs.rule.getValidRules()
        if (rules) {
          const name = GENERIC_NAME
          let res = localStorage.getItem(name)
          let tag = `${this.$route.meta.tag}?${this.module.module}`
          if (res) {
            try {
              res = JSON.parse(res)
              res[tag] = rules
              localStorage.setItem(name, JSON.stringify(res))
            } catch (e) {
            }
          } else {
            res = { [tag]: rules }
            localStorage.setItem(name, JSON.stringify(res))
          }
        }
      },
      // 清除当前通用查询缓存
      removeRulesLocal () {
        let res = localStorage.getItem(GENERIC_NAME) || '{}'
        let tag = `${this.$route.meta.tag}?${this.module.module}`
        if (res) {
          try {
            res = JSON.parse(res)
            delete res[tag]
            localStorage.setItem(GENERIC_NAME, JSON.stringify({...res}))
          } catch (e) {
            console.log(`[contom-filter]: ${e}`)
          }
        }
      },
      // 获取dom里非隐藏的input的value
      getActiveInputValue (dom) {
        return Array.from(dom.querySelectorAll('.el-input__inner'))
          .map(t => t.value && t.clientWidth ? t.value : '')
          .join(' ')
      },
      getQueryLog_zh_cn () {
        let el = this.$refs.rule && this.$refs.rule.$el
        if (!el) {
          return ''
        }
        let arr = []
        el.querySelectorAll('.el-table__row').forEach(tr => {
          // tr 包含有非隐藏的 el-select multiple
          let tags = tr.querySelectorAll('.el-select__tags-text')
          if (tags.length && tags[0].offsetWidth) {
            let text = Array.from(tr.childNodes).map((td, i) => {
              // 条件值td 包含有 el-select multiple
              if (i === 3) {
                // 通过正常的文本抓取不到正确的tags，通用查询的多选下拉框单独提供labels属性
                return Array.from(td.querySelectorAll('.el-select')).map(t => t.getAttribute('labels')).join('')
              }
              return this.getActiveInputValue(td)
            })
            arr.push(text.join(' '))
          } else {
            arr.push(this.getActiveInputValue(tr))
          }
        })
        return arr.join(' ').replace(/\s{2,}/g, ' ')
      },
      showNameDialog (val = true) {
        if (this.$refs.nameDialog) {
          this.$refs.nameDialog.show = val
        }
      },
      showImportDialog () {
        if (this.$refs.importDialog) {
          this.$refs.importDialog.show = true
        }
      },
      closeShareDialog() {
        if (this.$refs.shareDialog) {
          this.$refs.shareDialog.show = false
        }
      },
      showShareDialog () {
        if (this.$refs.shareDialog) {
          this.$refs.shareDialog.show = true
        }
      },
      /**
       * 重置模板
       */
      async onReset () {
        await this.$confirm('是否确认重置条件？', '提示')
        this.$refs.rule.onReset()
        this.removeRulesLocal()
        this.$emit('reset', { vm: this.$refs.rule })
      },
    }
  }
</script>

<style lang="scss">
  .kye-custom-filter-dialog > div > .el-dialog__body {
      padding: 0;
      overflow-y: hidden;
  }
  .kye-custom-filter-dialog {
    .main-wrap {
      display: flex;
      padding: 16px;
      &_left {
        width: 172px;
        border-right: 1px solid #dcdbe2;
        .tpl-popper {
          padding: 6px;
          .el-input__inner {
            padding-left: 24px !important;
            padding-right: 6px !important;
            border-radius: 4px;
            color: #333333;
            border-color: #e9e8ed;
            background-color: #ffffff;
          }
          .el-input__prefix {
            top: 5px;
            padding-left: 4px;
            font-size: 14px;
            color: #b3b1b1;
          }
        }
        .tpl-list {
          overflow: auto;
          .tpl {
            height: 24px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            &:hover {
              background-color: #f1f1f5;
            }
            .name {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
              cursor: pointer;
              font-size: 12px;
              max-width: 160px;
              padding: 4px 0;
            }
            .el-icon-edit {
              color: var(--g-color-primary);
              cursor: pointer;
            }
            .el-icon-delete {
              cursor: pointer;
            }
            .is-active {
              color: #ff9300;
              max-width: 126px;
            }
            .is-batch {
              max-width: 136px;
            }
          }
        }
        .el-scrollbar {
          height: 270px;
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
      }
      &_right {
        // width: 575px;
        margin-left: 12px;
        width: 658px;
        border: 1px solid #e9e8ed;
        border-radius: 4px;
      }
    }
    &__no-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      &-img {
        width: 80px;
        height: 60px;
      }
      &-text {
        font-size: 12px;
        color: #999999;
        line-height: 16px;
      }
    }
    &__footer {
      display: flex;
    }
  }
  .custom-filter-icon-size {
    font-size: 12px;
  }
  .kye-custom-filter > div > .el-dialog__body {
    padding: 0;
    overflow-y: hidden;

  }
  .kye-custom-filter {
    .main-wrap {
      display: flex;
      &_left {
        width: 172px;
        border-right: 1px solid #dcdbe2;
        .tpl-popper {
          padding: 6px;
          .el-input__inner {
            padding-left: 24px !important;
            padding-right: 6px !important;
            border-radius: 14px;
            color: #333333;
            border-color: #dbdae6;
            background-color: #ffffff;
          }
          .el-input__prefix {
            top: 5px;
            padding-left: 4px;
            font-size: 14px;
            color: #b3b1b1;
          }
        }
        .tpl-list {
          overflow: auto;
          .tpl {
            height: 24px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            &:hover {
              background-color: #f1f1f5;
            }
            .name {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
              cursor: pointer;
              font-size: 12px;
              max-width: 160px;
              padding: 4px 0;
            }
            .el-icon-edit {
              color: var(--g-color-primary);
              cursor: pointer;
            }
            .el-icon-delete {
              cursor: pointer;
            }
            .is-active {
              color: #ff9300;
              max-width: 126px;
            }
            .is-batch {
              max-width: 136px;
            }
          }
        }
        .el-scrollbar {
          height: 270px;
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
      }
      &_right {
        width: 575px;
      }
    }
    &__footer {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/custom-filter.vue